import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { requestBuilder } from '../../../http/RequestBuilder';
import { existingPaycheckRoutingConfigsAtom } from '../../state/PaycheckRoutingAtoms';
import {
    type PaycheckRoutingConfig,
    type PaycheckRoutingRule,
    PaycheckRoutingRuleType,
} from '../../types/PaycheckRouting';

const useGetPaycheckConfigs = requestBuilder.query<PaycheckRoutingConfig[]>({
    endpoint: () => '/api/paycheck-routing/list',
    queryKey: () => 'getConfigs',
});

const useGetExistingPaycheckConfigs = () => {
    const setAllConfigs = useSetAtom(existingPaycheckRoutingConfigsAtom);
    const {
        data: paycheckRoutingConfigs,
        isLoading,
        refetch,
    } = useGetPaycheckConfigs({});

    useEffect(() => {
        const transformRule = (
            rule: PaycheckRoutingRule,
        ): PaycheckRoutingRule => {
            return {
                ...rule,
                amount: parseFloat((rule.amount / 100).toFixed(2)),
            };
        };

        const transformedConfigs = (paycheckRoutingConfigs ?? []).map(
            (config) => {
                return {
                    ...config,
                    isLegacy:
                        config.originator != null || config.receiver != null,
                    rules: {
                        primary:
                            config?.rules
                                ?.filter(
                                    (rule) =>
                                        rule.type !==
                                        PaycheckRoutingRuleType.PERCENTAGE,
                                )
                                .map(transformRule)
                                .sort((a, b) => a.order - b.order) ?? [],
                        remaining:
                            config?.rules
                                ?.filter(
                                    (rule) =>
                                        rule.type ===
                                        PaycheckRoutingRuleType.PERCENTAGE,
                                )
                                .sort((a, b) => a.order - b.order) ?? [],
                    },
                };
            },
        );
        setAllConfigs(transformedConfigs);
    }, [paycheckRoutingConfigs]);

    return {
        paycheckRoutingConfigs,
        isLoading,
        refetch,
    };
};

export default useGetExistingPaycheckConfigs;
